import "core-js/modules/web.dom-exception.stack.js";
const _hiddenIframeId = '__hiddenIframe';
const _registerEvent = (target, eventType, cb) => {
  if (target.addEventListener) {
    target.addEventListener(eventType, cb);
    return {
      remove: () => {
        target.removeEventListener(eventType, cb);
      }
    };
  } else {
    target.attachEvent(eventType, cb);
    return {
      remove: () => {
        target.detachEvent(eventType, cb);
      }
    };
  }
};
const _createHiddenIframe = (target, uri) => {
  const iframe = document.createElement('iframe');
  iframe.src = uri;
  iframe.id = _hiddenIframeId;
  iframe.style.display = 'none';
  target.appendChild(iframe);
  return iframe;
};
const _openUriWithHiddenFrame = (uri, failCb) => {
  let iframe = document.querySelector('#' + _hiddenIframeId);
  if (!iframe) {
    iframe = _createHiddenIframe(document.body, 'about:blank');
  }
  let handler = {
    remove: () => {
      /**/
    }
  };
  const timeout = window.setTimeout(() => {
    failCb();
    handler.remove();
  }, 1000);
  function onBlur() {
    window.clearTimeout(timeout);
    handler.remove();
  }
  handler = _registerEvent(window, 'blur', onBlur);
  iframe.contentWindow.location.href = uri;
};

// Use hidden iframe to try and open our protocol, FF thorws a specific
// exception if this fails which can be used as a way to check if the protocol exists.
const _openUriUsingFirefox = (uri, failCb) => {
  let iframe = document.querySelector('#' + _hiddenIframeId);
  if (!iframe) {
    iframe = _createHiddenIframe(document.body, 'about:blank');
  }
  try {
    iframe.contentWindow.location.href = uri;
    // eslint-disable-next-line prettier/prettier
  } catch (e) {
    if (e instanceof Error && e.name === 'NS_ERROR_UNKNOWN_PROTOCOL') {
      failCb();
    }
  }
};
const _getInternetExplorerVersion = () => {
  let rv = -1;
  const ua = navigator.userAgent;
  if (navigator.appName === 'Microsoft Internet Explorer') {
    const re = new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})');
    if (re.exec(ua) != null) {
      rv = parseFloat(RegExp.$1);
    }
  } else if (navigator.appName === 'Netscape') {
    const re = new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})');
    if (re.exec(ua) != null) {
      rv = parseFloat(RegExp.$1);
    }
  }
  return rv;
};
const _openUriInNewWindowHack = (uri, failCb) => {
  const myWindow = window.open('', '', 'width=0,height=0');
  if (myWindow) {
    myWindow.document.write(`<iframe id="${_hiddenIframeId}" src="${uri}"></iframe>"`);
    window.setTimeout(() => {
      try {
        myWindow.location.href;
        myWindow.setTimeout('window.close()', 1000);
      } catch (e) {
        myWindow.close();
        failCb();
      }
    }, 1000);
  }
};
// IE on Windows 8 actually provides us with a method to check for a uri launching
const _openUriUsingIEInWindows8 = (uri, failCb) => {
  const nav = window.navigator;
  if (nav.msLaunchUri !== undefined) {
    nav.msLaunchUri(uri, undefined, failCb);
  }
};
const _openUriUsingIE = (uri, failCb) => {
  // check if OS is Win 8 or 8.1
  const isWin8 = 'msLaunchUri' in window.navigator;
  if (isWin8) {
    _openUriUsingIEInWindows8(uri, failCb);
  } else {
    switch (_getInternetExplorerVersion()) {
      case 11:
        _openUriWithHiddenFrame(uri, failCb);
        break;
      default:
        _openUriInNewWindowHack(uri, failCb);
    }
  }
};
const _verifyCookies = () => {
  try {
    window.document.cookie = 'cookietest=1';
    const cookiesEnabled = document.cookie.indexOf('cookietest=') !== -1;
    window.document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
    return cookiesEnabled;
  } catch (e) {
    return false;
  }
};

// MDN recommended function to check browser storage availability
// https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Feature-detecting_localStorage
const _verifyStorage = (local = false) => {
  let storage;
  try {
    storage = window[local ? 'localStorage' : 'sessionStorage'];
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return e instanceof DOMException && (
    // everything except Firefox
    e.code === 22 ||
    // Firefox
    e.code === 1014 ||
    // test name field too, because code might not be present
    // everything except Firefox
    e.name === 'QuotaExceededError' ||
    // Firefox
    e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
    // acknowledge QuotaExceededError only if there's something already stored
    storage && storage.length !== 0;
  }
};

/** Returns an object with properties that indicate what the current browser type is  */
export const checkBrowser = () => {
  const isOpera = !!window['opera'] || window.navigator.userAgent.indexOf(' OPR/') >= 0;
  return {
    isChrome: !!window['chrome'] && !isOpera,
    isEdge: /Edge\/\d+/.test(window.navigator.userAgent),
    isFirefox: typeof window['InstallTrigger'] !== 'undefined',
    isIE: !!document['documentMode'],
    // At least IE6
    isOpera: isOpera,
    isSafari: navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1,
    isIPhone: navigator.userAgent.indexOf('iPhone') !== -1,
    isAndroid: /Android/i.test(navigator.userAgent)
  };
};
/**
 * Collects broswer information. This is used primarily by the upload process to keep track
 * of what environment user's are uploading with.
 */
export const getBrowserDiagnostics = () => {
  // const navAppVersion = navigator.appVersion;
  const navUserAgent = window.navigator.userAgent;
  let browser = window.navigator.appName;
  let version = parseFloat(window.navigator.appVersion).toString();
  let majorVersion = parseInt(window.navigator.appVersion, 10);
  let nameOffset, versionOffset, trimVersion;

  // Opera
  if ((versionOffset = navUserAgent.indexOf('Opera')) !== -1) {
    browser = 'Opera';
    version = navUserAgent.substring(versionOffset + 6);
    if ((versionOffset = navUserAgent.indexOf('Version')) !== -1) {
      version = navUserAgent.substring(versionOffset + 8);
    }
  }

  // Opera Next
  if ((versionOffset = navUserAgent.indexOf('OPR')) !== -1) {
    browser = 'Opera';
    version = navUserAgent.substring(versionOffset + 4);
  }
  // MSIE
  else if ((versionOffset = navUserAgent.indexOf('MSIE')) !== -1) {
    browser = 'Microsoft Internet Explorer';
    version = navUserAgent.substring(versionOffset + 5);
  }
  // Chrome
  else if ((versionOffset = navUserAgent.indexOf('Chrome')) !== -1) {
    browser = 'Chrome';
    version = navUserAgent.substring(versionOffset + 7);
  }
  // Safari
  else if ((versionOffset = navUserAgent.indexOf('Safari')) !== -1) {
    browser = 'Safari';
    version = navUserAgent.substring(versionOffset + 7);
    if ((versionOffset = navUserAgent.indexOf('Version')) !== -1) {
      version = navUserAgent.substring(versionOffset + 8);
    }
  }
  // Firefox
  else if ((versionOffset = navUserAgent.indexOf('Firefox')) !== -1) {
    browser = 'Firefox';
    version = navUserAgent.substring(versionOffset + 8);
  }
  // MSIE 11+
  else if (navUserAgent.indexOf('Trident/') !== -1) {
    browser = 'Microsoft Internet Explorer';
    version = navUserAgent.substring(navUserAgent.indexOf('rv:') + 3);
  } else if (/android/i.test(navUserAgent)) {
    browser = 'Android';
  } else if (/iPad|iPhone|iPod/.test(navUserAgent)) {
    const winMSStream = window;
    if (!winMSStream.MSStream) {
      browser = 'iOS';
    }
  }
  // Other browsers
  else if ((nameOffset = navUserAgent.lastIndexOf(' ') + 1) < (versionOffset = navUserAgent.lastIndexOf('/'))) {
    browser = navUserAgent.substring(nameOffset, versionOffset);
    version = navUserAgent.substring(versionOffset + 1);
    if (browser.toLowerCase() === browser.toUpperCase()) {
      browser = window.navigator.appName;
    }
  }

  // trim the version string
  if ((trimVersion = version.indexOf(';')) !== -1) {
    version = version.substring(0, trimVersion);
  }
  if ((trimVersion = version.indexOf(' ')) !== -1) {
    version = version.substring(0, trimVersion);
  }
  if ((trimVersion = version.indexOf(')')) !== -1) {
    version = version.substring(0, trimVersion);
  }
  majorVersion = parseInt('' + version, 10);
  if (isNaN(majorVersion)) {
    version = '' + parseFloat(window.navigator.appVersion);
    majorVersion = parseInt(window.navigator.appVersion, 10);
  }
  return {
    browser: browser,
    browserVersion: version,
    browserMajorVersion: majorVersion,
    supportsCookies: _verifyCookies(),
    supportsLocalStorage: _verifyStorage(false),
    supportsSessionStorage: _verifyStorage(true)
  };
};

/**
 * Attempts to fire a protocol message using a method that works for each browser/version
 */
export const fireProtocolMessage = function (uri, failCb) {
  const browser = checkBrowser();
  const failCallback = () => {
    failCb && failCb();
  };
  if (browser.isFirefox) {
    _openUriUsingFirefox(uri, failCallback);
  } else if (browser.isEdge) {
    _openUriUsingIEInWindows8(uri, failCallback);
  } else if (browser.isIE) {
    _openUriUsingIE(uri, failCallback);
  } else {
    window.location.assign(uri);
  }
};